module.exports = __webpack_public_path__ + "media/footer/chile-48b3719e.png";